<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="15" viewBox="0 0 23 15">
    <g transform="translate(-695 -401)">
      <rect
        width="22"
        height="1"
        transform="translate(695.5 401)"
        fill="#777"
      />
      <path
        d="M432,546H409v-3h23Zm-22-1h21v-1H410Z"
        transform="translate(286 -138)"
        fill="#777"
      />
      <path
        d="M432,554H409v-5h23Zm-22-1h21v-3H410Z"
        transform="translate(286 -138)"
        fill="#777"
      />
    </g>
  </svg>
</template>
